import MonacoEditor from "react-monaco-editor"
const Editor = MonacoEditor
export default Editor
